<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="false" />

    <div style="width: 100%; height: 800px">
      <div style="width: 35%; margin: 40px auto; height: 300px">
        <div style="overflow: hidden; margin: auto" >
          <div style="text-align: center; margin-left: 20px" v-if="!chengong">
            <div class="shezhichegong">
              <img
                src="../assets/wangjimima1.png"
                style="width: 40px; height: 46px"
                alt=""
              />
              <span style="margin-left: 10px">设置登录密码</span>
            </div>

            <div style="overflow: hidden; margin-top: 20px; position: relative">
              <div class="left_txt1">登录密码</div>
              <div>
                <div style="overflow: hidden">
                  <input
                    v-model="paw1"
                    :type="passsword1_t ? 'text' : 'password'"
                    class="shuru1"
                    placeholder="请输入登录密码"
                    name=""
                    id=""
                  />
                </div>
                <span class="mima_tishi"
                  >*
                  密码由6-16位字符，可包含数字、字母(区分大小写)、特殊符号组合而成</span
                >
              </div>
              <img
                @click="passsword1_t = !passsword1_t"
                v-if="passsword1_t"
                src="../assets/wangjimima_kanbujian.png"
                style="
                  margin-top: 10px;
                  width: 16px;
                  height: 8px;
                  position: absolute;
                  right: 0;
                  top: 10px;
                  cursor: pointer;
                "
                alt=""
              />
              <img
                @click="passsword1_t = !passsword1_t"
                v-else
                src="../assets/wangjimima_kandejian.png"
                style="
                  margin-top: 10px;
                  width: 16px;
                  height: 8px;
                  position: absolute;
                  right: 0;
                  top: 10px;
                  cursor: pointer;
                "
                alt=""
              />
            </div>

            <div style="overflow: hidden; margin-top: 20px; position: relative">
              <div class="left_txt1">确认登录密码</div>
              <div>
                <div style="overflow: hidden">
                  <input
                    v-model="paw2"
                    :type="passsword2_t ? 'text' : 'password'"
                    type="text"
                    class="shuru1"
                    placeholder="请再次输入登录密码"
                    name=""
                    id=""
                  />
                </div>
              </div>
              <img
                @click="passsword2_t = !passsword2_t"
                v-if="passsword2_t"
                src="../assets/wangjimima_kanbujian.png"
                style="
                  margin-top: 10px;
                  width: 16px;
                  height: 8px;
                  position: absolute;
                  right: 0;
                  top: 10px;
                  cursor: pointer;
                "
                alt=""
              />
              <img
                @click="passsword2_t = !passsword2_t"
                v-else
                src="../assets/wangjimima_kandejian.png"
                style="
                  margin-top: 10px;
                  width: 16px;
                  height: 8px;
                  position: absolute;
                  right: 0;
                  top: 10px;
                  cursor: pointer;
                "
                alt=""
              />
            </div>

            <div class="tijiao" @click="tijiao">确定</div>
          </div>

        <div style="overflow: hidden" v-else>
          <img
            src="../assets/wangjimima1.png"
            style="width: 40px; height: 46px; float: left; margin-left: 50px;margin-top: 50px;"
            alt=""
          />
          <div style="float: left; margin-left: 20px">
            <div class="shezhichegong" style="margin-top: 50px;">登录密码设置成功！</div>
            <div class="tiaozhuan">
              {{ daojishi }}秒后自动跳转至科隆商城首页，或
              <router-link to="/"
                ><span style="color: #2b9a34">点此</span></router-link
              >
              进入首页
            </div>
          </div>
        </div>

        </div>


      </div>
    </div>

    <foot />
  </div>
</template>

<script>
import axios from "axios";
import htmlHeader from "../public/head";
import foot from "../public/foot";
import swiperRight from "../public/swiper_right";
export default {
  name: "index",
  components: {
    htmlHeader,
    foot,
    swiperRight,
  },
  data() {
    return {
      daojishi: 3,
      passsword1_t: false,
      passsword2_t: false,
      paw1: "",
      paw2: "",
      _ok: false,
      chengong: false,
    };
  },
  methods: {
    jishiqi() {
      let _t = setInterval(() => {
        this.daojishi--;
        if (this.daojishi == 0) {
          window.clearInterval(_t);
          this.$router.push("/");
        }
      }, 1000);
    },
    tijiao() {
      if (this.paw1 == "" || this.paw2 == "") {
        this.$message.error("请输入密码");
        return false;
      }
      if (this.paw1 != this.paw2) {
        this.$message.error("两次密码不一致");
        return false;
      }
      this.api
        .pwdSetFirst({
          passwordCopy: this.paw2,
          password: this.paw1,
        })
        .then((res) => {
          if (res.ok) {
            this._ok = true;
            this.chengong = true
            this.jishiqi();
          } else {
            this.$message.error(res.message);
          }
        });
    },
  },
  created() {},
};
</script>
<style scoped>
.mima_tishi {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-left: 60px;
  margin-top: 20px;
}
.shuru1 {
  width: 500px;
  height: 48px;
  border: 1px solid #ede9e9;
  margin-left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  padding: 10px;
  outline: none;
}
.left_txt1 {
  width: 100px;
  text-align: right;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  float: left;
  margin-top: 10px;
}
.shezhichegong {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.tiazhuan {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 20px;
  color: #333333;
}

.tijiao {
  width: 100px;
  height: 40px;
  border: 1px solid #2b9a34;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
  margin: 20px auto;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/login_password.vue